import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/css/addunit.css";
import "../../assets/css/mainMenu.css";
import "../../assets/css/permisions.css";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import plus1 from "../../assets/icons/plus1.svg";
import fetchWrapper from "../../AuthMiddleware/FetchWrapper";
import { useNavigate } from "react-router-dom";
import { hasPermission } from "../../Services/authUtils";

const Permission = () => {
  const [localToggledAbilities, setLocalToggledAbilities] = useState({});

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [abilities, setAbilities] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState({
    role_id: "",
    role_name: "",
  });

  const [userId, setUserId] = useState(null);

  // Function to get the user data from session storage
  const fetchUserData = () => {
    const userData = sessionStorage.getItem("user");

    if (userData) {
      const user = JSON.parse(userData);
      setUserId(user.role_id);

    } else {
      console.error("No user data found in session storage.");
    }
  };

  // Fetch user data on component mount
  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchAllRoles = async () => {
    setLoading(true);
    try {
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/role/getall`,
        { method: "POST" },
        navigate // Pass navigate here
      );

      setRoles(data.roles);
    } catch (error) {
      console.error("Error fetching role groups:", error);
      setRoles([]);
    }
    setLoading(false);
  };

  const fetchAllAbilities = async (roleId) => {
    setLoading(true);
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/abilities/getall?role_id=${roleId}`;

      const response = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate
      );

      if (Array.isArray(response.data)) {

        setAbilities(response.data);
      } else {
        console.error("Unexpected API response structure:", response);
        setAbilities([]);
      }
    } catch (error) {
      console.error("Error fetching Abilities:", error);
      setAbilities([]);
    }
    setLoading(false);
  };

  const addPermission = async () => {
    setLoading(true);
    const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/upload-abilities`;

    try {
      await fetchWrapper(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      toast.success("Added successfully");
      fetchAllAbilities(selectedRole.role_id); // Call fetchAllAbilities after adding the permission
    } catch (error) {
      console.error("Error:", error);

      if (error.response && error.response.status === 401) {
        navigate("/auth/login");
      } else {
        toast.error("Something went wrong");
      }
    }
    setLoading(false);
  };

  const toggleSelectedAbility = (abilityId, currentStatus) => {
    setLocalToggledAbilities((prevToggledAbilities) => ({
      ...prevToggledAbilities,
      [abilityId]: !currentStatus,
    }));

    // Update the UI immediately
    setAbilities((prevAbilities) =>
      prevAbilities.map((module) => ({
        ...module,
        abilities: module.abilities.map((ability) =>
          ability._id === abilityId
            ? { ...ability, status: !ability.status }
            : ability
        ),
      }))
    );
  };

  const handleSubmit = async () => {
    setLoading(true);
    const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/abilities/add`;

    try {
      const toggledAbilitiesArray = Object.keys(localToggledAbilities).map(
        (abilityId) => ({
          role_id: selectedRole.role_id,
          ability_id: abilityId,
          status: localToggledAbilities[abilityId],
        })
      );

      await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(toggledAbilitiesArray),
        },
        navigate
      );

      toast.success("Selected abilities changed successfully");

      // Clear the local state after submission
      setLocalToggledAbilities({});
    } catch (error) {
      console.error("Error submitting abilities:", error);
      toast.error("Error submitting abilities");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAllRoles();
    // fetchAllAbilities(selectedRole.role_id); // Fetch abilities for the selected role on component mount or when the selected role changes
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <div className="show-breadcrumb pt-3">
              <h5 className="">Permissions</h5>
              <nav className="breadcrumb-nav" aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item ">
                    <a className="">Configure</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a className="">User Settings</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Permissions
                  </li>
                </ol>
              </nav>
            </div>

            <div className="d-flex gap-3">
              <div className="dropdown">
                <div className="dropdown">
                  <select
                    id="cars"
                    style={{ height: "40px", width: "200px" }}
                    className="select-unit textarea"
                    value={selectedRole.role_id}
                    onChange={(e) => {
                      const selectedRoleId = e.target.value;
                      const selectedRole = roles.find(
                        (role) => role._id === selectedRoleId
                      );
                      setSelectedRole({
                        role_id: selectedRoleId,
                        role_name: selectedRole ? selectedRole.role_name : "",
                      });
                      fetchAllAbilities(selectedRoleId);
                    }}
                  >
                    <option value="">Select Role</option>
                    {/* {roles.map((role) => (
                      <option key={role._id} value={role._id}>
                        {role.role_name}
                      </option>
                    ))} */}
                    {roles.map(
                      (role) =>
                        role._id !== userId && ( // Condition to exclude the role with ID equal to userId
                          <option key={role._id} value={role._id}>
                            {role.role_name}
                          </option>
                        )
                    )}
                  </select>
                </div>
              </div>

              <button
                type="button"
                id="openPopup"
                className="btn-bg d-flex align-items-center"
                style={{
                  height: "40px",
                  width: "200px",
                  padding: "12px 12px",
                }}
                onClick={handleSubmit}
              >
                <span className="plus-icon">
                  <img src={plus1} alt="Plus Icon" />
                </span>
                <div> Submit Changes</div>
              </button>
            </div>
          </div>

          <div className="permission-container">
            <div className="d-flex justify-content-between align-items-center mt-2 mx-2"></div>
            <div>
              {loading ? (
                <p>Loading...</p>
              ) : (
                <div className="tablegrid-container ">
                  {abilities.length > 0 ? (
                    abilities.map((module, moduleIndex) => (
                      <div
                        key={module.module_id}
                        className="table-responsive tablegrid-item table-responsive1 "
                      >
                        <h5>{module.module_name}</h5>
                        <table className="table align-middle table-text">
                          <thead className="table-head align-middle">
                            <tr>
                              <th className="col">ID</th>
                              <th className="col">ABILITY</th>
                              <th className="col">DESCRIPTION</th>
                              {hasPermission(["permission.update"]) && (
                                <th className="col">STATUS</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {module.abilities.map((ability, index) => (
                              <tr key={ability._id}>
                                <td>{index + 1}</td>
                                <td>{ability.ability}</td>
                                <td>{ability.description}</td>
                                <td>
                                  <span className="align-content-center switcher">
                                    <label className="switch switch1">
                                      <input
                                        type="checkbox"
                                        checked={ability.status}
                                        onChange={() =>
                                          toggleSelectedAbility(
                                            ability._id,
                                            ability.status
                                          )
                                        }
                                      />
                                      <span className="slider slider1 round"></span>
                                    </label>
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ))
                  ) : (
                    <p style={{ marginLeft: "10px", display: "none" }}>
                      No abilities found.
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ToastContainer autoClose={2000} position={"top-right"} />
    </>
  );
};

export default Permission;
